import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

const AuthLayout = ({ children }) => {
  const location = useLocation();

  return (
    <div className='flex h-screen flex-col md:flex-row'>
      {location?.pathname !== '/privacy-policy' ? (
        <>
          <div className='relative overflow-hidden m-4 md:m-[40px] md:ml-[50px] rounded-[30px] order-1 md:order-none w-full md:w-1/2 hidden md:block'>
            <picture>
              <source srcSet='/farm.webp' type='image/webp' />
              <img
                src='/farm.jpg'
                alt='Logo'
                fetchPriority='high'
                className='h-full w-full object-cover object-center'
              />
            </picture>
            <div
              className='absolute inset-0 z-10 opacity-50'
              style={{
                background:
                  'linear-gradient(180deg, rgba(23, 6, 69, 0) 0%, #170645 100%), linear-gradient(180deg, rgba(0, 0, 0, 0.1) 16.35%, rgba(0, 0, 0, 0) 23.32%)',
              }}
            />
            <div className='absolute bottom-[20px] md:bottom-[50px] left-[20px] md:left-[40px] z-20 text-white'>
              <h1 className='mb-0 font-primarySemiBold text-[32px] md:text-[48px] leading-[40px] md:leading-[56px]'>
                Empowering Farmers
              </h1>
              <div className='ml-[3px] w-[90%] text-[14px] md:text-[16px] font-medium leading-[18px] md:leading-[20px]'>
                Effortlessly manage farmer training, monitor compliance, and promote sustainability.
              </div>
            </div>
          </div>
          <div className='w-full md:w-1/2 p-4 md:p-0 order-2 md:order-none'>
            <Suspense fallback={null}>{children}</Suspense>
          </div>
        </>
      ) : (
        <>
          <div className='w-full p-4 md:p-0 order-2 md:order-none'>
            <Suspense fallback={null}>{children}</Suspense>
          </div>
        </>
      )}
    </div>
  );
};

export default AuthLayout;
